<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import lottie, { type AnimationItem } from 'lottie-web'
import swiftyWave from '@/assets/images/swifty.json'

const props = defineProps<{
  /** Lottie JSON. Defaults to the waving Swifty used on the welcome card. */
  animationData?: Record<string, unknown>
}>()

const containerRef = ref<HTMLElement | null>(null)
let animation: AnimationItem | null = null

onMounted(() => {
  if (!containerRef.value) {
    return
  }

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches

  animation = lottie.loadAnimation({
    container: containerRef.value,
    renderer: 'svg',
    loop: !prefersReducedMotion,
    autoplay: !prefersReducedMotion,
    animationData: props.animationData ?? swiftyWave,
  })

  if (prefersReducedMotion) {
    animation.goToAndStop(0, true)
  }
})

onBeforeUnmount(() => {
  animation?.destroy()
  animation = null
})
</script>

<template>
  <div ref="containerRef" class="sa-swifty-lottie" aria-hidden="true" />
</template>
